import React, { useEffect, useState } from 'react';

import "../App.css"

import { useTranslation } from 'react-i18next'

// components
import GlobalHeaader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';
import SearchDesciption from "../components/SearchDesciption.js";
import SelectActivity from '../components/SelectActivity'
import ImpactQuestions from '../components/ImpactQuestions';
import BlawxQuestions from '../components/BlawxQuestions';
import KumuQuestions from '../components/KumuQuestions';
import KumuQuestionsV2 from '../components/KumuQuestionsV2';
import Results from '../components/Results';
import ActivityCard from "../components/ActivityCard"
import ActivityPicker from "../components/ActivityPicker"
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import LegislationCard from "../components/LegislationCard.js"
import LegislationPicker from "../components/LegislationPicker.js"
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import ProgressBar from '../components/ProgressBar.js';
// utils
import { mapNLGQuestions } from './utils/blawxHelper'
import { getActivities, getCategories, getTranslatedText } from './utils_v2/kumuHelper';
// actions
import { getOnto } from '../api/blawksAPI';
import { getElements, getConnections } from '../api/blawksAPI'
// constants
import { QuestionPhase } from '../constants';
import ResultSummaryTable from '../components/ResultSummaryTable.js';

export default function GuidedSearch() {

    const { t, i18n } = useTranslation('translation')

    const [selectedActivities, setSelectedActivities] = React.useState([]);
    const [questionPhase, setQuestionPhase] = React.useState(QuestionPhase.ACTIVITYSELECT);

    const [elements, setElements] = useState([]);
    const [connections, setConnections] = useState([]);

    const kumuElements = require('../api/kumu_elements.json');
    const kumuEdges = require('../api/kumu_edges.json');

    const [categories, setCategories] = useState([]);
    const [activities, setActivities] = useState([]);

    const [isSubmit, setIsSubmit] = useState(false);

    const [legislation, setLegislation] = useState([])
    const [currentlegislation, setCurrentLegislation] = useState([])

    const [isLoading, setIsLoading] = useState(true);
    const [results, setResults] = useState([]);
    const [history, setHistory] = useState([]);

    const legislationIds = new Set(legislation.map(l => l.id));
    const list = elements?.rows?.filter(item=> item.value.attributes['element type'] === 'regulation' && !legislationIds.has(item.id))

    const [showLeaveModal, setShowLeaveModal] = useState(false);
    const allowNavigationRef = React.useRef(false);


    useEffect(() => {
        // setBlawxsOnto(response)
        // setQuestions(mapNLGQuestions(response.AttributeNLG, response.Attributes, response.Objects))
        // getOnto(1, "generic_3_1").then((response)=>{

        //     setIsLoading(false)
        // });
        // getElements('CSmith109', 'map-tool-21').then(res => {
        //     setElements(res)
        //     setCategories(getCategories(res))
        //     setIsLoading(false)
        // })
        // getConnections('CSmith109', 'map-tool-21').then(res => {
        //     setConnections(res)
        // })
        setElements(kumuElements)
        setCategories(getCategories(kumuElements))
        setConnections(kumuEdges)
        setIsLoading(false)

        // setActivities(getActivities())
    }, []);

    useEffect(() => {
        const handleLinkClick = (e) => {
        const anchor = e.target.closest("a");
        if (!anchor) return;

        const href = anchor.getAttribute("href") || "";
        const target = anchor.getAttribute("target") || "";
        const isHash = href.startsWith("#");
        const isMailto = href.startsWith("mailto:");
        const isTel = href.startsWith("tel:");
        const isNewTab = target === "_blank";
        const isExternal = anchor.origin && anchor.origin !== window.location.origin;

        if (isHash || isMailto || isTel || isNewTab || isExternal) {
            allowNavigationRef.current = true;
        }
};

        const handleBeforeUnload = (event) => {
            if (allowNavigationRef.current) return;
            event.preventDefault();
            event.returnValue = "";
        };

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1);

        const handlePopState = (event) => {
            if (allowNavigationRef.current) {
                allowNavigationRef.current = false;
                return;
            }

            window.history.pushState(null, "", window.location.href);

            if (isIOS) {
                setShowLeaveModal(true);
                return;
            }

            const confirmMessage = i18n.language === 'fr'
                ? "Êtes-vous sûr de vouloir revenir en arrière? Les modifications non enregistrées pourraient être perdues."
                : "Are you sure you want to go back? Unsaved changes may be lost.";

            if (window.confirm(confirmMessage)) {
                allowNavigationRef.current = true;
                window.history.back();
            }
        };

        document.addEventListener("click", handleLinkClick);
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopState);
        window.history.pushState(null, "", window.location.href);

        return () => {
            document.removeEventListener("click", handleLinkClick);
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("popstate", handlePopState);
        };
    }, [questionPhase, i18n.language]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [questionPhase])

    const handlePageTitle = (status) => status == QuestionPhase.RESULTS ? t("Your results:") : t("Guided Search")    

    const handlePhase = (status) => {
        switch (status) {
            case QuestionPhase.ACTIVITYSELECT:
                return (
                    <div>
                        <SearchDesciption desc={
                            <>
                                <p>{t('The Mine Permit Navigator will ask you to identify activities you plan to include in your mining project. Based on the activities you select, the tool will:')}</p>
                                <ul>
                                    <li>{t('Identify federal legislation that may apply to your project.')}</li>
                                    <li>{t('Provide information on how to apply for permits and authorizations.')}</li>
                                </ul>
                                <p>{t('From the dropdown list below, select all the categories of work that apply to your project.')}</p>
                            </>
                        } />
                        <SelectActivity
                            selectedActivities={selectedActivities}
                            setSelectedActivities={setSelectedActivities}
                            categories={categories}
                            questionPhase={questionPhase}
                            setQuestionPhase={setQuestionPhase}
                            setIsSubmit={setIsSubmit}
                            isSubmit={isSubmit}
                            setLegislation={setLegislation}
                            setResults={setResults}
                            setActivities={setActivities}
                        />
                        {isSubmit ?
                            <ActivityPicker
                                categories={getActivities(elements, connections, selectedActivities, i18n.language)}
                                setActivities={setActivities}
                                activities={activities}
                                setLegislation={setLegislation}
                                setQuestionPhase={setQuestionPhase}
                                elements={elements}
                                connections={connections} /> : null}

                    </div>
                )
            // -- Not used as of V2 --
            // case QuestionPhase.PREQUESTIONS:
            //     return (
            //         <div>
            //             <SearchDesciption desc={<p>We need to know a little bit about your project to find your best matches.</p>}/>
            //             <SelectActivity 
            //                 selectedActivities={selectedActivities} 
            //                 setSelectedActivities={setSelectedActivities} 
            //                 activites={activities}
            //             />
            //             <SearchDesciption desc={<p>Please answer the following questions: </p>}/>
            //             <ImpactQuestions
            //                 selectedActivites={selectedActivities} 
            //                 setQuestionPhase={setQuestionPhase}  
            //                 legislation={legislation} 
            //                 setLegislationParent={setLegislation}
            //                 elements={elements}
            //                 connections={connections}
            //             />
            //         </div>
            //     )
            case QuestionPhase.LEGISLATIONS:
                return (
                    <div>
                        <SearchDesciption desc={<p>
                            {t(
                                'Based on the categories and activities you selected, you may have responsibilities under the pieces of legislation listed below. You can click on each legislation title to navigate to its information box and learn more about what applies to you, or you can scroll down. Answer the related questions for each piece of legislation to determine your responsibilities. Once you have completed all sections, scroll to the bottom of the page and click "Show Results" to view your full summary.'
                            )}
                            </p>} 
                        />
                        <SearchDesciption desc={
                            <ul style={{ marginLeft: '2.5rem' }}>
                                {legislation
                                    .slice()
                                    .sort((a, b) => {
                                        const labelA = getTranslatedText(i18n.language, a.value.attributes.label).toLowerCase();
                                        const labelB = getTranslatedText(i18n.language, b.value.attributes.label).toLowerCase();
                                        return labelA.localeCompare(labelB);
                                    })
                                    .map(leg => (
                                        <li key={leg.id}>
                                            <a href={`#${leg.value.attributes.label}`}>
                                                <i>{getTranslatedText(i18n.language, leg.value.attributes.label)}</i>
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>}
                        />
                        <LegislationPicker 
                            legislations={legislation} 
                            setActivities={setActivities} 
                            setQuestionPhase={setQuestionPhase} 
                            setCurrentLegislation={setCurrentLegislation} 
                            results={results} 
                        />
                        
                        {list && list.length > 0 && (
                            <>
                            <SearchDesciption desc={<p>
                                {t(
                                    'Please note that the Acts and Regulations listed below are included in the tool, but based on your current selections, they were not applied. Mining projects often have broad environmental impacts, which typically trigger requirements under legislation such as the Fisheries Act, the Migratory Birds Convention Act and its associated Regulations, and the Species at Risk Act. It is your responsibility to identify and comply with all applicable requirements under these and any other relevant laws. To explore these Acts and Regulations further, please expand your activity selections in the previous step or click on the hyperlinks below to open an information page about the legislation.'
                                )}
                                </p>} 
                            />
                            <SearchDesciption desc={
                                <ul style={{ marginLeft: '2.5rem' }}>
                                    {list.map(leg => (
                                        <li key={leg.id}>
                                            <a href={`/${i18n.language}/overview/${leg.value.attributes["reference id"]}`} target="_blank">
                                                <i>{getTranslatedText(i18n.language, leg.value.attributes.label)}</i>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            } />
                            </>
                        )}
                    </div>
                )
            case QuestionPhase.SUBQUESTIONS:
                return (
                    <div>
                        <SearchDesciption desc={<h3 id={getTranslatedText(i18n.language, currentlegislation.value.attributes.label)} style={{ fontSize: "28px" }}>{t("Learn more about the")} <i>{getTranslatedText(i18n.language, currentlegislation.value.attributes.label)}</i></h3>} />
                        {/* <SearchDesciption desc={<p>{t("Select the statements below that apply to your project and click 'Continue' to find out your responsibilities under this legislation. To explore other laws and regulations that may apply to your project, click 'Back' to return to the relevant legislation list.")}</p>} /> */}
                        <KumuQuestionsV2 currentLegislation={currentlegislation} setCurrentLegislation={setCurrentLegislation} results={results} setResults={setResults} setQuestionPhase={setQuestionPhase} elements={elements} connections={connections} />
                    </div>
                )
            case QuestionPhase.RESULTS:
                return (
                    <div>
                        <SearchDesciption desc={<p>{t("Based on your answers to the questions presented in Step 2, here are your results: ")}</p>} />
                        {/* <ResultSummaryTable legislation={legislation} legislationResults={results} /> */}
                        <Results legislationResults={results} legislation={legislation} setQuestionPhase={setQuestionPhase} />
                    </div>
                )
            // case QuestionPhase.RESULTS:
            //     return (
            //         <div>
            //             <SearchDesciption desc={<p>Based on what you told us, here's what we have for you: </p>}/>
            //             <Results answerList = { blawxOnto.Facts ? answerList.concat(blawxOnto.Facts.facts) : answerList}/>
            //         </div>
            //     )
        }
    }

    return (
        <div>
            <header>
                <GlobalHeaader />
                <Menu />
                <BreadcrumbTrail isSearch="true" />
            </header>

            {isLoading ?
                <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                    <Stack>
                        <Skeleton variant="text" height={75} width={400} />
                        <Skeleton variant="text" height={90} />
                        <Skeleton variant="text" height={75} />
                    </Stack>
                </main>
                :
                <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                    <h2 property="name" id="wb-cont">{handlePageTitle(questionPhase)}</h2>
                    <ProgressBar status={questionPhase}/>
                    {handlePhase(questionPhase)}
                </main>}

            {showLeaveModal && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        background: 'white', borderRadius: '8px', padding: '30px',
                        maxWidth: '400px', width: '90%', textAlign: 'center'
                    }}>
                        <p style={{ marginBottom: '20px', fontSize: '16px' }}>
                            {i18n.language === 'fr'
                                ? "Êtes-vous sûr de vouloir revenir en arrière? Les modifications non enregistrées pourraient être perdues."
                                : "Are you sure you want to go back? Unsaved changes may be lost."}
                        </p>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                            <button
                                onClick={() => {
                                    setShowLeaveModal(false);
                                    allowNavigationRef.current = true;
                                    window.history.back();
                                }}
                                style={{
                                    padding: '10px 20px', backgroundColor: '#d3080c',
                                    color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'
                                }}
                            >
                                {i18n.language === 'fr' ? "Quitter" : "Leave"}
                            </button>
                            <button
                                onClick={() => setShowLeaveModal(false)}
                                style={{
                                    padding: '10px 20px', backgroundColor: '#555',
                                    color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'
                                }}
                            >
                                {i18n.language === 'fr' ? "Rester" : "Stay"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ReportProblem />
            <GlobalFooter />
        </div>
    );
}